import {Component, OnInit} from '@angular/core';
import {IReviewItem} from './reviews-item/reviews-item.component';

@Component({
    selector: 'app-reviews',
    templateUrl: './reviews.component.html',
    styleUrls: ['./reviews.component.scss']
})
export class ReviewsComponent implements OnInit {

    data;
    reviews: IReviewItem[] = [];

    constructor() {
    }

    ngOnInit(): void {
        this.data = [
            {
                imgSrc: './assets/img/ann.png',
                name: 'Анна M.',
                title: 'корисно знати, що моє...',
                text: ' уникання негативу є видимим.',
            },
            {
                imgSrc: null,
                name: 'Катерина К.',
                title: 'відзначила що в більшості...',
                text: 'концентрую увагу на негативних емоціях, буду звертати на це увагу в майбутньому.'
            },
            {
                imgSrc: './assets/img/oleh.png',
                name: 'Олег Л.',
                title: 'я люблю відстежувати стрес...',
                text: 'результат тесту мене здивував, важко повірити в його правдивість. Однак тепер я буду більш позитивно оцінювати свій ментальний стан і займатися самоаналізом, тому в будь-якому випадку це було корисно.'
            },
            {
                imgSrc: null,
                name: 'Марія К.',
                title: 'тест дав усвідомити що...',
                text: 'рівень тривоги більший ніж я думала.'
            },
            {
                imgSrc: null,
                name: 'Людмила В.',
                title: 'покращення відносин',
                text: ''
            },
            {
                imgSrc: 'assets/img/irynaD.png',
                name: 'Ірина Д.',
                title: 'розуміння себе краще',
                text: ''
            },
            {
                imgSrc: null,
                name: 'Анастасія С.',
                title: 'корисно було відстежити...',
                text: 'динаміку змін характеристик по закінченню тижня.'
            },
            {
                imgSrc: 'assets/img/dmytroN.png',
                name: 'Дмитро Н.',
                title: 'сподобалась ідея про...',
                text: 'відсутність потреби у фокусуванні на негативі'
            },
            {
                imgSrc: null,
                name: 'Олена Д.',
                title: 'Зрозуміла, що напруження...',
                text: ' це ок, не завжди потрібно його позбуватись'
            },
            {
                imgSrc: 'assets/img/ivanM.png',
                name: 'Іван М.',
                title: 'рекомендації застосували...',
                text: 'у інтроспекції, після прочитання легше диференціювати свій стан'
            },
            {
                imgSrc: 'assets/img/olhaV2.png',
                name: 'Ольга В.',
                title: 'картинки з тортом...',
                text: 'мене надихнули зробити десерт'
            },
            {
                imgSrc: null,
                name: 'Любов А.',
                title: 'відкрила для себе кілька...',
                text: 'нових понять, з якими раніше не була знайома. зрозуміла чому у мене низька працездатність'
            },
            {
                imgSrc: null,
                name: 'Аліна К.',
                title: 'думала, що маю серйозні...',
                text: 'проблеми з вигоранням, проте тест показав що все ок, може я дійсно перебільшую'
            },
            {
                imgSrc: 'assets/img/olhaV.png',
                name: 'Ольга В.',
                title: 'Я бачу, що в мене всі...',
                text: 'показники в нормі - значить все в мене окей, то додає спокою.'
            },
            {
                imgSrc: null,
                name: 'Данило К.',
                title: 'я намагаюсь частіше...',
                text: 'слідкувати за тим на що направлена моя увага, на чому я взагалі легко концентруюсь, на чому важко мені концентруватись.'
            }
        ];
    }

    pageChange(prop) {
        this.reviews = prop;
    }

}
